module.exports = __webpack_public_path__ + "static/img/appdow_bk2_app_nr.b7d8751.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_bk2_app_nr.gif
// module id = WmJP
// module chunks = 4